"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var featureflip_1 = require("@getgo/featureflip");
var PropTypes = require("prop-types");
var react_1 = require("react");
var FeatureFlipProvider = (function (_super) {
    __extends(FeatureFlipProvider, _super);
    function FeatureFlipProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureFlipProvider.prototype.getChildContext = function () {
        return {
            featureFlip: this.props.context,
        };
    };
    FeatureFlipProvider.prototype.render = function () {
        return react_1.Children.only(this.props.children);
    };
    return FeatureFlipProvider;
}(react_1.PureComponent));
FeatureFlipProvider.childContextTypes = {
    featureFlip: PropTypes.instanceOf(featureflip_1.default),
};
exports.default = FeatureFlipProvider;
//# sourceMappingURL=FeatureFlipProvider.js.map